import React, { FC, useMemo } from 'react';
import Avatar from 'src/common/Avatar';
import classNames from 'classnames';
import styles from './index.module.scss';
import { AccessControlPolicy } from 'src/models/acl/types';
import { Skeleton } from 'antd';
import { useEmployees } from 'src/models/users/hooks';
import { IUserName } from 'src/models/users/types';

interface IProps {
  owners: IUserName[] | undefined;
  subscribersList: IUserName[] | undefined;
  accessControlPolicy: AccessControlPolicy | undefined;
  onClick?: () => void;
  loading?: boolean;
  size?: 's' | 'xs' | 'm' | 'l' | 'xl' | undefined;
}
export const MemberList: FC<IProps> = props => {
  const { owners, subscribersList, accessControlPolicy, onClick, loading, size } = props;

  const { data: employees, loading: employeeLoading } = useEmployees();

  const isLoading = loading || employeeLoading;

  const subscribePolicyIsAll = accessControlPolicy === AccessControlPolicy.ALL;
  const employeesList = useMemo(() => employees?.personel.filter(emp => emp.enabled) || [], [employees?.personel]);

  const availableCount = 12;

  const preparedSubscribersList = useMemo(() => {
    return subscribePolicyIsAll ? employeesList : subscribersList;
  }, [employeesList, subscribePolicyIsAll, subscribersList]);

  const subscribers = useMemo(() => {
    const ownersLen = owners?.length || 0;
    return preparedSubscribersList && preparedSubscribersList.slice(0, availableCount - ownersLen);
  }, [owners, preparedSubscribersList]);

  const label = useMemo(() => {
    const ownersLen = owners?.length || 0;
    const subscribersLen = preparedSubscribersList?.length || 0;
    const membersLen = ownersLen + subscribersLen;
    return membersLen > availableCount ? membersLen - availableCount : null;
  }, [owners, preparedSubscribersList]);

  return (
    <div className={styles.container}>
      {isLoading && <Skeleton.Button active className={styles.skeleton} />}
      {!isLoading && (
        <>
          <div className={classNames(styles.unit, styles.ownersUnit)}>
            {owners &&
              owners.map(user => (
                <button onClick={onClick} className={styles.avatarButton} key={`owner_${user.email}`}>
                  <Avatar
                    className={classNames(styles.avatar, styles.borderedAvatar)}
                    bordered
                    showTooltip
                    user={user}
                    size={size}
                  />
                </button>
              ))}
          </div>
          <div className={classNames(styles.unit, styles.subscribersUnit)}>
            {subscribers &&
              subscribers.map(user => {
                return (
                  <button onClick={onClick} className={styles.avatarButton} key={`subscriber_${user.email}`}>
                    <Avatar
                      className={classNames(styles.avatar, styles.borderedAvatar)}
                      bordered
                      showTooltip
                      user={user}
                      size={size}
                    />
                  </button>
                );
              })}

            {!!label && <div className={styles.count}>{`+${label}`}</div>}
          </div>
        </>
      )}
    </div>
  );
};

export default MemberList;
